import React, { PropsWithChildren } from 'react';
import styles from './Callout.module.scss';

export function Callout({ children }: PropsWithChildren<{}>) {
  return <blockquote className={styles.body}>{children}</blockquote>;
}
